import { type PayloadAction } from '@reduxjs/toolkit';
import { type QuestionEditorsState } from './Question.Editor.Slice';
import { mergeRulesById, removeRulesByIds } from './ruleMerge';
import type { TQuestionRule } from 'types/rules.types';

// Local-editor-state counterpart to the template rule editor, for a question with no template in
// scope (question creation flow, standalone question editor). There's no override/default split
// here — the question's own `rules` array is the only copy, so a pending rule is merged straight
// onto it and carried along whenever the whole document is next saved.
export const questionRulesReducer = {
  upsertQuestionRule: (
    state: QuestionEditorsState,
    action: PayloadAction<{ questionId: string; rule: TQuestionRule }>,
  ) => {
    const { questionId, rule } = action.payload;
    if (state.byId[questionId]) {
      state.byId[questionId].rules = mergeRulesById(state.byId[questionId].rules ?? [], [rule]);
      state.byId[questionId].stateModified = true;
    }
  },

  removeQuestionRule: (state: QuestionEditorsState, action: PayloadAction<{ questionId: string; ruleId: string }>) => {
    const { questionId, ruleId } = action.payload;
    if (state.byId[questionId]) {
      state.byId[questionId].rules = removeRulesByIds(state.byId[questionId].rules ?? [], [ruleId]);
      state.byId[questionId].stateModified = true;
    }
  },
};
